<template>
  <div>
    <b-alert
      variant="success"
      :show="showAlert_success"
      @dismissed="showAlert_success = false"
      >{{ alert_success_message }}</b-alert
    >

    <b-alert
      variant="danger"
      :show="showAlert_error"
      @dismissed="showAlert_error = false"
      >{{ alert_error_message }}</b-alert
    >

    <b-container fluid>
      <h3 class="mt-3 mb-3">Address Template Management</h3>

      <div class="action_bar mb-3">
        <b-button
          class="btn-action-lg"
          size="sm"
          variant="info"
          :to="{ name: 'address_template_add' }"
        >Add Address</b-button>
      </div>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <b-table
        responsive
        small
        outlined
        striped
        hover
        sticky-header="500px"
        :items="items"
        :fields="fields"
      >
        <!-- Display Remark Field -->
        <template v-slot:cell(remark)="data">
          <div>{{ data.item.remark }}</div> <!-- Remark value here -->
        </template>

        <!-- Updated At Field -->
        <template slot="updated_at" slot-scope="data">
          <div v-if="data.item.updated_by != ''">
            {{ data.item.updated_at }}
          </div>
        </template>

        <!-- Action Buttons for Edit and Delete -->
        <template v-slot:cell(action)="data">
          <b-button
            class="btn-default"
            size="sm"
            variant="primary"
            :to="{
              name: 'address_template_edit',
              params: { address_template_id: data.item.id }
            }"
          >Edit</b-button>

          <b-button
            class="btn-danger"
            size="sm"
            variant="primary"
            @click.stop="showModal_confirmDelete(data.item)"
          >Delete</b-button>
        </template>
      </b-table>

      <b-pagination
        size="sm"
        :total-rows="total_rows"
        v-model="currentPage"
        :per-page="TABLE_LIMIT"
        @change="onPageChange"
        :limit="PAGING_LIMIT"
      ></b-pagination>

      <!-- Confirmation Modal for Deletion -->
      <b-modal ref="modal_confirmDelete" centered hide-footer hide-header>
        <div class="d-block">
          <b-row class="mb-3">
            <b-col>Are you sure you want to delete this address?</b-col>
          </b-row>
        </div>
        <div class="text-right">
          <b-btn
            class="mt-3"
            variant="outline-danger"
            @click="hideModal_confirmDelete"
          >Cancel</b-btn>
          <b-btn
            class="mt-3"
            variant="outline-success"
            @click="deleteAddress"
          >Confirm</b-btn>
        </div>
      </b-modal>
    </b-container>
  </div>
</template>

<script>
import moment from "moment";

// Define table fields, including the new "remark" field
const fields = [
  { key: "template_name", label: "Template Name" },
  { key: "name", label: "Name" },
  { key: "phone", label: "Phone" },
  { key: "district", label: "District" },
  { key: "address", label: "Address" },
  { key: "remark", label: "Remark" }, // Add remark field
  { key: "created_at", label: "Created at" },
  { key: "created_by_name", label: "Created by" },
  { key: "action", label: "Action" },
];

export default {
  name: "OrderAddresses",
  inject: ["API_HOST", "TABLE_LIMIT", "PAGING_LIMIT"],
  data() {
    return {
      items: [], // Store table data
      fields: fields, // Include fields in table
      currentPage: 1,
      table_offset: 0,
      total_rows: 0,
      showAlert_success: false,
      alert_success_message: "",
      showAlert_error: false,
      alert_error_message: "",
    };
  },
  async created() {
    await this.getOrderAddresses();
  },
  methods: {
    // Fetch the address templates
    async getOrderAddresses() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "address_template_get.php",
        data: {
          offset: this.table_offset,
          limit: this.TABLE_LIMIT,
          user_id: this.$store.state.user_obj.user_id,
          client_id: this.$store.state.user_obj.client_id,
        },
      });
      this.items = response.data.templates; // Fetch data into items
      this.total_rows = parseInt(response.data.total_rows);
    },

    // Handle pagination
    onPageChange(page_to_change) {
      this.table_offset = (page_to_change - 1) * this.TABLE_LIMIT;
      this.getOrderAddresses();
    },

    // Show delete confirmation modal
    showModal_confirmDelete(item) {
      this.$refs.modal_confirmDelete.item = item;
      this.$refs.modal_confirmDelete.show();
    },

    // Hide delete confirmation modal
    hideModal_confirmDelete() {
      this.$refs.modal_confirmDelete.hide();
    },

    // Delete the selected address
    async deleteAddress() {
      let response = await this.$http({
        method: "POST",
        baseURL: `${this.API_HOST}`,
        url: "address_template_delete.php",
        data: {
          address_id: this.$refs.modal_confirmDelete.item.id,
          client_id: this.$store.state.user_obj.client_id,
          user_id: this.$store.state.user_obj.user_id,
        },
      });
      this.getOrderAddresses(); // Refresh the table after deletion
      this.hideModal_confirmDelete();
    },
  },
};
</script>

<style>
th,
td {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/AddressTemplate.vue